/* eslint-disable react-refresh/only-export-components */
import { ServiceNowAuthManager } from "@buzzeasy/crm-fragment";
import { Spin } from "antd";
import { useEffect } from "react";
import ReactDOM from "react-dom/client";

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
ReactDOM.createRoot(document.getElementById("root")!).render(
  <App />,
);

function App() {
  useEffect(
    () => { new ServiceNowAuthManager().popupAuthCallback(); },
    [],
  );

  return <Spin fullscreen />;
}
